function initProductSellingPlan() {
  window.handleOneTimeChange = function handleOneTimeChange(event) {
    var oneTimeRadio = event.target;
    var sellingPlanInput = document.getElementById('selling_plan');
    var otPurchase = document.getElementById('otPurchase');
    var subPurchase = document.getElementById('subPurchase');
    if (oneTimeRadio.checked) {
      sellingPlanInput.value = '';
      otPurchase.classList.add('active');
      subPurchase.classList.remove('active');
    }
  };
  window.handleSubscriptionChange = function handleSubscriptionChange(event) {
    var subscriptionRadio = event.target;
    var subscriptionWidgetContainer = document.querySelector('.subscription_widget__container');
    var sellingPlanSelect = subscriptionWidgetContainer.querySelector('#subscriptionPlan');
    var sellingPlanInput = document.getElementById('selling_plan');
    var otPurchase = document.getElementById('otPurchase');
    var subPurchase = document.getElementById('subPurchase');
    if (subscriptionRadio.checked) {
      sellingPlanInput.value = sellingPlanSelect.options[sellingPlanSelect.selectedIndex].value;
      otPurchase.classList.remove('active');
      subPurchase.classList.add('active');
    }
  };
  window.handleSellingPlanChange = function handleSellingPlanChange(event) {
    var sellingPlanSelect = event.target;
    var subscriptionRadio = document.querySelector('input[name="purchaseOption"][value="subscription"]');
    var sellingPlanInput = document.getElementById('selling_plan');
    var subscriptionPrice = document.querySelector('.subscribe__price');
    var subscriptionSave = document.querySelector('.subscription__save');
    if (subscriptionRadio.checked && subscriptionPrice) {
      sellingPlanInput.value = sellingPlanSelect.value;
      var optionSelected = sellingPlanSelect.options[sellingPlanSelect.selectedIndex];
      subscriptionPrice.textContent = optionSelected.dataset.price;
      subscriptionSave.textContent = optionSelected.dataset.discount;
    }
  };
}
export { initProductSellingPlan };